// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "micro-base-static/css/" + (chunkId === 699 ? "system" : chunkId) + "." + {"699":"f8683ac4","717":"c0ee26c9","960":"c7b3e701"}[chunkId] + ".chunk.css";
};